const CMS_UPLOAD_CONFIG = {
  wordpress: {
    articleField: 'wordpress_id',
    pageField: 'wordpress_id',
    label: 'WordPress'
  },
  webflow: {
    articleField: 'webflow_id',
    pageField: 'webflow_id',
    label: 'Webflow'
  },
  shopify: {
    articleField: 'shopify_id',
    pageField: 'shopify_id',
    label: 'Shopify'
  },
  magento: {
    articleField: 'magento_id',
    pageField: 'magento_id',
    label: 'Magento'
  },
  'custom-cms': {
    articleField: 'custom_cms_id',
    pageField: 'custom_cms_id',
    label: 'Custom CMS'
  }
}

const normalizeCmsId = (value) => {
  if (value === undefined || value === null) return null
  const normalized = String(value).trim()
  if (!normalized) return null
  return normalized
}

export const isCmsUploadDecisionEnabled = (integration) => {
  if (!integration) return false
  if (integration === 'none') return false
  if (integration === 'gecko-cms') return false
  return integration !== 'autoblog'
}

export const getCmsUploadConfig = (integration) => {
  return CMS_UPLOAD_CONFIG[integration] || null
}

export const getCmsLabel = (integration) => {
  if (integration === 'autoblog') return 'Autoblog'
  if (integration === 'gecko-cms') return 'Gecko CMS'
  return getCmsUploadConfig(integration)?.label || 'CMS'
}

export const buildCmsUploadDecision = ({ integration, article = {}, page = null }) => {
  const cmsConfig = getCmsUploadConfig(integration)
  const cmsLabel = getCmsLabel(integration)

  if (!cmsConfig) {
    return {
      code: 'generic-upload',
      severity: 'info',
      confirmLabel: 'Upload',
      message: `Uploading will send this article to ${cmsLabel}.`,
      cmsIdOverride: null
    }
  }

  const articleCmsId = normalizeCmsId(article[cmsConfig.articleField])
  const pageCmsId = normalizeCmsId(page?.[cmsConfig.pageField])
  const pageUrl = page?.url || article?.url || article?.article_url || 'unknown URL'

  if (!articleCmsId) {
    if (!page) {
      return {
        code: 'create-new-page',
        severity: 'info',
        confirmLabel: 'Upload',
        message: 'Uploading will create a new live page.',
        cmsIdOverride: null
      }
    }

    if (pageCmsId) {
      return {
        code: 'overwrite-page-id',
        severity: 'warning',
        confirmLabel: 'Confirm',
        message: `Uploading will overwrite live page: ${pageUrl}. ${cmsLabel} ID: ${pageCmsId}`,
        cmsIdOverride: pageCmsId
      }
    }

    return {
      code: 'matched-page-without-id',
      severity: 'error',
      confirmLabel: 'Upload as new page',
      message: "The matched URL can't be updated.",
      detail: `Matched URL: ${pageUrl}`,
      cmsIdOverride: null
    }
  }

  if (page && pageCmsId && pageCmsId !== articleCmsId) {
    return {
      code: 'article-page-id-mismatch',
      severity: 'warning',
      confirmLabel: 'Confirm',
      message: `Articles and page CMS IDs don't match. Uploading will overwrite live page: ${pageUrl}. ${cmsLabel} ID: ${pageCmsId}`,
      cmsIdOverride: pageCmsId
    }
  }

  const overwriteMessage = page
    ? `Uploading will overwrite live page: ${pageUrl}. ${cmsLabel} ID: ${articleCmsId}`
    : `Uploading will overwrite live page. ${cmsLabel} ID: ${articleCmsId}`

  return {
    code: 'overwrite-article-id',
    severity: 'info',
    confirmLabel: 'Confirm',
    message: overwriteMessage,
    cmsIdOverride: null
  }
}
